const activeRoleSessionName = "ActiveRoleIndex";


export function setActiveRoleIndex(msal: any, index: string) {
    localStorage.setItem(activeRoleSessionName, index);
}
